export const FETCH_TABLES_BEGIN = "FETCH_DATABASE_BEGIN";
export const FETCH_TABLES_SUCCESS = "FETCH_DATABASE_SUCCESS";
export const FETCH_TABLES_FAILURE = "FETCH_DATABASE_FAILURE";
